import React, { FC } from 'react'

import { WishlistButton } from '@Components/WishList/WishlistButton'
import { useWishList } from '@Domains/WishList/Hooks'
import { useTranslation } from '@Globals/Translations'

interface AddToWishListProps {
  className?: string
  id: string
  size?: 'small'
  sourceID?: string
}

export const AddToWishList: FC<AddToWishListProps> = ({ className, id, size, sourceID }) => {
  const [selected, toggle] = useWishList(id, sourceID)
  const { t } = useTranslation('products')

  return (
    <WishlistButton
      className={className}
      label={t(selected ? 'REMOVE_FROM_WISH_LIST' : 'ADD_TO_WISH_LIST')}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        toggle()
      }}
      selected={selected}
      small={size === 'small'}
    />
  )
}
